/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['leaflet', './iconContent'], function(L, iconContent) {
    'use strict';
    var classes = {
        container: 'tomtom-point-content__name-container',
        name: 'tomtom-point-content__name'
    };

    return function(parentPoiData, type) {
        var div,
            span;

        div = L.DomUtil.create('div', classes.container);
        div.appendChild(iconContent(parentPoiData));

        span = L.DomUtil.create('span', classes.name, div);
        span.innerHTML = [parentPoiData.name, type, 'entry'].join(' ');

        return div;
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/details/entryPointContent.js